//Re-bind for ajax callbacks
jQuery(document).ready(function () {
  bmyb.init();

  var stripeState = false;

  jQuery("span.jquery-checkbox span.mark").click(function () {
    if (jQuery(this).parent().parent().hasClass("Stripe-option")) {
      if (stripeState) {
        console.log("Switching off stripe image");
        jQuery("#Stripe3-preview").removeClass("show");
        jQuery("#hulllogo").show();
        stripeState = false;
      } else {
        console.log("Switching on stripe image");
        jQuery("#Stripe3-preview").addClass("show");
        jQuery("#hulllogo").hide();
        stripeState = true;
      }
    } else {
      if (stripeState && jQuery(this).parent().parent().hasClass("Vinyl-option")) {
        console.log("Switching off stripe image");
        jQuery("#Stripe3-preview").removeClass("show");
        jQuery("#hulllogo").show();
        stripeState = false;
      }

    }
  });

});